// extracted by mini-css-extract-plugin
export default {"show-menu-border":"index_show-menu-border__QUfEz","item":"index_item__1+EC-","active":"index_active__fwe5J"};